import { render, staticRenderFns } from "./SelectProjectRole.vue?vue&type=template&id=da66f780&lang=pug"
import script from "./SelectProjectRole.vue?vue&type=script&lang=js"
export * from "./SelectProjectRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports